module.exports = __webpack_public_path__ + "img/scheme-top3.3ad9a9b8.png";